import {all, call, cancel, delay, put, select, takeEvery, takeLatest,} from 'redux-saga/effects';
import {ARTICLES_FETCH_ARTICLE, ARTICLES_LOAD_LIST} from '@src/_redux/articles/constants';
import {IReduxRootState} from '@src/@interfaces';
import {
    articlesFetchArticle,
    articlesReplaceArticle,
    articlesSetErrorMessage,
    articlesSetList,
    articlesSetNowLoading
} from '@src/_redux/articles/actions';
import {IArticleModel} from '@src/@interfaces/models/Article/IArticleModel';
import app from '@src/helpers/app';
import {randomInteger} from '@src/helpers/rand';

export function* articlesFetchListSaga() {
    yield takeLatest(ARTICLES_LOAD_LIST, function* () {
        yield put(articlesSetErrorMessage(null));

        const haveToCancel: boolean = yield select((state: IReduxRootState) => {
            return state.articles.isLoading || state.articles.isLoaded;
        });
        if (haveToCancel) {
            yield cancel();

            return;
        }

        try {
            yield put(articlesSetNowLoading(true));

            const articles: IArticleModel[] = yield call(() => {
                return app('http').route('articles.index', {}, {
                    json: {
                        'controller-name': 'Articles',
                    }
                });
            });

            yield put(articlesSetList(articles));
        } catch (e) {
            yield put(articlesSetErrorMessage(
                e != null && e instanceof Error ?
                    e.message :
                    'Something went wrong'
            ));
            yield delay(randomInteger(5, 15) * 1000);
            yield put(articlesSetNowLoading(false));
        }
    });
}

export function* articlesFetchArticleSaga() {
    yield takeEvery(ARTICLES_FETCH_ARTICLE, function* ({payload: {articleId}}: ReturnType<typeof articlesFetchArticle>) {
        yield put(articlesSetErrorMessage(null));

        if (articleId == null) {
            yield cancel();

            return;
        }

        const article: IArticleModel | null = yield select((state: IReduxRootState) => {
            return state.articles.articles.find(item => item.id === articleId);
        });
        if (article != null && 'content' in article) {
            yield cancel();

            return;
        }

        yield put(articlesReplaceArticle({...article, content: null}));

        try {
            const data: IArticleModel = yield call(() => {
                return app('http').route('articles.show', {
                    id: String(articleId),
                }, {
                    json: {'controller-name': 'Articles'},
                });
            });

            yield put(articlesReplaceArticle(data));
        } catch (e) {
            yield put(
                articlesSetErrorMessage(
                    e != null && e instanceof Error ?
                        e.message :
                        'Something went wrong'
                )
            );
        }
    });
}

export function* articlesSaga() {
    yield all([
        articlesFetchListSaga(),
        articlesFetchArticleSaga(),
    ]);
}
